import Cookie from "js-cookie";
import moment, { MomentInput } from "moment";
import numbro from "numbro";
import { useEffect, useRef } from "react";
import Swal, { SweetAlertOptions, SweetAlertResult } from "sweetalert2";
import docPdf from "../assets/Posterity_Whitepaper_V3.0.0.pdf";
// import BNBBEP20 from "../assets/img/network/bnb.png";
// import BTCBitcoin from "../assets/img/networks/BTCBitcoin.png";
// import ETHERC20 from "../assets/img/newNetwork/ethereum.png";
// import TRXTRC20 from "../assets/img/newNetwork/tron.png";
// import USDTBEP20 from "../assets/img/networks/USDT-BEP20.png";
// import USDTERC20 from "../assets/img/networks/USDT-ERC20.png";
// import USDTTRC20 from "../assets/img/networks/USDT-TRC20.png";

import BTCBitcoin from "../assets/img/networks/BTCBitcoin.png";
import ETHERC20 from "../assets/img/networks/ethereum.png";
import BNBBEP20 from "../assets/img/networks/bnb.png"
import TRXTRC20 from "../assets/img/newNetwork/tron.png";
import USDTBEP20 from "../assets/img/networks/USDT-BEP20.png";
import USDTERC20 from "../assets/img/networks/USDT-ERC20.png";
import USDTTRC20 from "../assets/img/networks/USDT-TRC20.png";
// @ts-ignore
import walletValidator from "multicoin-address-validator";
import * as Yup from "yup";
import {
  TCoinNetWorkArr,
  TNetworkedCoin,
} from "./interfaces/withdraw/TCoinNetWorkArr";
import { TCryptoPairs } from "./interfaces/withdraw/withdraw-interfaces";

const createBrowserHistory = require("history").createBrowserHistory;

export const history = createBrowserHistory({ forceRefresh: true });
export const noRefreshHistory = createBrowserHistory({ forceRefresh: false });

export const noRefreshRedirectTo = (path: string) =>
  noRefreshHistory.push(path);
export const redirectTo = (path: string) => history.push(path);

type Delay = number | null;
type TimerHandler = (...args: any[]) => void;

export const SWAL_CONF: SweetAlertOptions = {
  showClass: {
    popup: "animate__animated animate__bounceIn animate__faster",
  },
  hideClass: {
    popup: "animate__animated animate__bounceOut animate__faster",
  },
  showCloseButton: true,
  allowOutsideClick: false,
  buttonsStyling: false,
  allowEscapeKey: true,
  allowEnterKey: true,
  heightAuto: false,
  customClass: {
    confirmButton: "swal2ConfirmButton",
    cancelButton: "swal2CancelButton",
    closeButton: "swal2CloseButton",
    actions: "swal2Actions",
    content: "swal2Content",
    denyButton :"swal2DenyButton"
  },
};


export const SWAL_CONF_WARNING: SweetAlertOptions = {
  allowOutsideClick: false,
  buttonsStyling: false,
  allowEscapeKey: true,
  allowEnterKey: true,
  heightAuto: false,
  customClass: {
    confirmButton: "swal2ConfirmButtonwarning",
    denyButton :"swal2DenyButtonwarning"
  },
};

export const TIME_FORMAT = "YYYY MMMM Do HH:mm";
export const NUMERIC_TIME_FORMAT = "YYYY.M.D HH:MM";
export const NUMERIC_TIME_FORMAT_WITH_SZ = "YYYY.MM.DD HH:mm"; //S:seconds Z:timezone
export const CYCLE_DURATION_IN_MILLISECONDS = 2678400000;

export const timeFormat = (timeStamp: MomentInput) =>
  moment(moment(timeStamp).toLocaleString()).format(TIME_FORMAT);

export const numericTimeFormat = (timeStamp: MomentInput) =>
  moment(moment(timeStamp).toLocaleString()).format(
    NUMERIC_TIME_FORMAT_WITH_SZ
  );

// eslint-disable-next-line
export const EMAIL_REGEX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const useInterval = (callback: TimerHandler, delay: Delay) => {
  const savedCallbackRef = useRef<TimerHandler>();

  useEffect(() => {
    savedCallbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    const handler = (...args: any[]) => savedCallbackRef.current!(...args);

    if (delay !== null) {
      const intervalId = setInterval(handler, delay);
      return () => clearInterval(intervalId);
    }
  }, [delay]);
};

export const REQUEST = "REQUEST";
export const SUCCESS = "SUCCESS";
export const FAILURE = "FAILURE";

export function createRequestTypes(base: string): { [key: string]: string } {
  return [REQUEST, SUCCESS, FAILURE].reduce(
    (acc: { [key: string]: string }, type) => {
      acc[type] = `${base}_${type}`;
      return acc;
    },
    {}
  );
}

export function ajaxErrorAlert(
  text?: string,
  title?: string,
  otherArgs?: any
): Promise<SweetAlertResult> {
  return Swal.fire({
    ...SWAL_CONF,
    title,
    text: `${text}`,
    ...otherArgs,
    icon: "error",
  });
}

export function ajaxWarningAlert(
  text?: string,
  title?: string,
  html?: string,
  otherArgs?: any
): Promise<SweetAlertResult> {
  return Swal.fire({
    ...SWAL_CONF,
    icon: "warning",
    title: title,
    text: `${text}`,
    html: html,
    reverseButtons: true,
    showCancelButton: true,
    showConfirmButton: true,
    confirmButtonText: "Confirm",
    cancelButtonText: "Cancel",
  });
}



export function ajaxConfirmAlert(
  title?: string,
  text?:string,
  confirmButtonText?: string,
  denyButtonText?:string
): Promise<SweetAlertResult> {
  return Swal.fire({
    ...SWAL_CONF_WARNING,
    icon: "warning",
    showDenyButton: true,
    title,
    text,
    denyButtonText: denyButtonText ? denyButtonText : 'Skip',
    confirmButtonText: confirmButtonText ? confirmButtonText : "Confirm the cancelation",
  });
}


export function noConfirmAjaxWarningAlert(
  text?: string,
  otherArgs?: any
): Promise<SweetAlertResult> {
  return Swal.fire({
    ...SWAL_CONF,
    icon: "warning",
    text: `${text}`,
    reverseButtons: true,
    ...otherArgs,
  });
}

export const passwordStrongChecker = new RegExp(
  "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})"
);

export function ajaxSuccessAlert(
  text: string,
  title?: string,
  otherArgs?: any ,
  confirmButtonText ?: any
): Promise<SweetAlertResult> {
  return Swal.fire({
    ...SWAL_CONF,
    icon: "success",
    title: title,
    text: `${text}`,
    confirmButtonText: "Continue",
    ...otherArgs,
  });
}

export function ajaxSuccessAlertCancelDeposit(
  text: string,
  title?: string,
  otherArgs?: any ,
  confirmButtonText ?: any
): Promise<SweetAlertResult> {
  return Swal.fire({
    ...SWAL_CONF,
    icon: "success",
    title: title,
    text: `${text}`,
    confirmButtonText: "Return to the Deposit page",
    ...otherArgs,
  });
}

export const currencyFormat = (
  value?: number,
  precision?: number,
  spaceSeparated: boolean = false
): string =>
  numbro(value)
    .formatCurrency({
      mantissa: precision ? precision : 2,
      average: false,
      spaceSeparated: spaceSeparated,
      optionalMantissa: true,
      thousandSeparated: true,
      spaceSeparatedCurrency: spaceSeparated,
    })
    .toUpperCase();

export const percentageFormat = (value?: number): string =>
  value
    ? numbro(value)
        .format({
          output: "percent",
          mantissa: 2,
          optionalMantissa: true,
          negative: "parenthesis",
        })
        .toUpperCase()
    : "";

export const customLengthNumberFormat = (
  value?: number,
  length?: number
): string =>
  value
    ? numbro(value)
        .format({
          output: "number",
          mantissa: length ? length : 2,
          negative: "parenthesis",
        })
        .toUpperCase()
    : "";

export function showLoading(
  title: string = "Please Wait...",
  text: string = "Please wait while we process your request..."
) {
  Swal.fire({
    ...SWAL_CONF,
    title,
    text,
    allowEscapeKey: false,
    allowOutsideClick: false,
    showCloseButton: false,
    showConfirmButton: false,
    didOpen(modalElement: HTMLElement): void {
      Swal.showLoading();
    },
  });
}

export function ucFirst(str: string) {
  if (str) {
    return str
      .substr(0, str.length)
      .split("-")
      .map((item) => item[0].toUpperCase() + item.slice(1))
      .join(" ");
  }
}

export const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const depositLifeTime = 21427200;

export const calculateRemainingLifeTime = (start: number, end: number) =>
  `${moment(start * 1000).diff(end * 1000, "months")}  Months`;

export const numberFormatter = (value: number) =>
  numbro(value).format({
    thousandSeparated: true,
    mantissa: 2,
    optionalMantissa: true,
  });

export const earningBackgroundColorCalculator = () => {
  const colors = ["206a5d", "fecd1a", "fd8c04", "fa1616"];

  const eightYears = 8 * 365 * 3600000;
  let startDate = 1608488266921,
    endDate = 1608488266921 + eightYears;
  let totalAge = endDate - startDate;

  let firstPeriod = totalAge * 0.33333333333;

  let firstPeriodColorRange = parseInt(colors[1], 16) - parseInt(colors[0], 16);
  if (moment(Date.now()).isSameOrBefore(startDate + firstPeriod)) {
    return (
      parseInt(colors[0], 16) +
      firstPeriodColorRange / (firstPeriod + startDate)
    ).toFixed(0);
  }
};

export const downloadWhitPaperModal = (downloadLink = docPdf) => {
  Swal.fire({
    ...SWAL_CONF,

    text: "To learn more, please download the Posterity whitepaper as a PDF file. All information on how Posterity works, investing method, Affiliate plans and many more details are available on the Posterity whitepaper. To begin download click on the Download button.",
    showCancelButton: true,
    cancelButtonText: "Maybe later",
    showConfirmButton: true,
    confirmButtonText: "Download",
  })
    .then((res) => {
      if (res.isConfirmed) {
        const win = window.open(downloadLink, "_self");
        win?.focus();
        Swal.close();
      }
    })
    .catch((err) => {
      console.error(err);
    });
};

export const capitalize = (el: string) => {
  if (el) {
    return el
      .substr(0, el.length)
      .split("-")
      .map((item) => item[0].toUpperCase() + item.slice(1))
      .join(" ");
  }
};

export const acceptableCoins = [
  "BTC",
  "ETH",
  "BNB",
  "DOT",
  "XRP",
  "ADA",
  "LTC",
  "LINK",
  "THETA",
  "BCH",
  "XLM",
  "TRX",
  "FIL",
  "BTT",
  "DOGE",
  "VET",
  "EOS",
  "LUNA",
  "XMR",
  "MIOTA",
  "HOT",
  "BSV",
  "ATOM",
  "XTZ",
  "NEO",
  "FTT",
  "XEM",
  "HT",
  "DASH",
  "MKR",
  "SNX",
  "ZIL",
  "ZEC",
  "ENJ",
  "LEO",
  "TFUEL",
  "BAT",
  "ETC",
  "MATIC",
  "ALGO",
];
export const removeCookie = () => Cookie.remove("token");

export const logout = () => {
  showLoading("", "Please wait while we process your request...");
  if (Cookie.get("token")) {
    removeCookie();
  }
  localStorage.clear();
  sessionStorage.clear();
  redirectTo("/auth");
};

export const actionCreator = (type: any, payload: any) => ({
  type: type,
  payload: payload,
});

export function NetworkToCoin(network: number | undefined) {
  switch (network) {
    case 1:
      return "BTC";

    case 2:
      return "ETH";

    case 3:
      return "BNB";
    case undefined:
      return "";
    default:
      return "";
  }
}

export function CoinToNetwork(coinType: string | undefined) {
  switch (coinType) {
    case "BTC":
      return 1;
    case "ETH":
      return 2;
    case "BNB":
      return 3;
    case undefined:
      return 0;
    default:
      return 0;
  }
}


export const getImg = (cryptoName: string, networkName: string) => {
  if(cryptoName + networkName === 'BTCBitcoin' ) {
    return BTCBitcoin;
  }
  else if (cryptoName + networkName === 'ETHERC20' ) {
    return ETHERC20;
  } else if(cryptoName + networkName === 'TRXTRC20'){
    return TRXTRC20
  } else if(cryptoName + networkName === 'USDTBEP20') {
    return USDTBEP20
  } else if(cryptoName + networkName === "USDTERC20"){
    return USDTERC20
  } else if(cryptoName + networkName === "USDTTRC20"){
    return USDTTRC20
  } else if(cryptoName + networkName === 'BNBBEP20' ){
    return BNBBEP20
  }
}

export const networkedCoins = [
  {
    networkName: "ERC20",
    coinSymbol: "ETH",
    icon: ETHERC20,
  },
  {
    networkName: "Bitcoin",
    coinSymbol: "BTC",
    icon: BTCBitcoin,
  },
  {
    networkName: "BEP20",
    coinSymbol: "BNB",
    icon: BNBBEP20,
  },
  {
    networkName: "TRC20",
    coinSymbol: "TRX",
    icon: TRXTRC20,
  },
  {
    networkName: "BEP20",
    coinSymbol: "USDT",
    icon: USDTBEP20,
  },
  {
    networkName: "ERC20",
    coinSymbol: "USDT",
    icon: USDTERC20,
  },
  {
    networkName: "TRC20",
    coinSymbol: "USDT",
    icon: USDTTRC20,
  },
] as const;



export function findCryptoPairBycoinNetworkArr(
  coinNetworkArr: TCoinNetWorkArr,
  cryptoPairs: TCryptoPairs
) {
  return cryptoPairs.find(
    (cryptoPair) =>
      cryptoPair.cryptoSymbol === coinNetworkArr[0] &&
      cryptoPair.networkName === coinNetworkArr[1]
  );
}

export const COINS = [
  {
    assetLogo: {
      encoding: "base64",
      imageData:
        "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",
      mimeType: "image/png",
    },
    assetName: "Ethereum",
    assetOriginalSymbol: "ETH",
    assetSymbol: "ETH",
    assetType: "crypto",
    slug: "ethereum",
    disabled: false,
  },
  {
    assetLogo: {
      encoding: "base64",
      imageData:
        "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48Y2lyY2xlIGN4PSIxNiIgY3k9IjE2IiByPSIxNiIgZmlsbD0iI0Y3OTMxQSIvPjxwYXRoIGZpbGw9IiNGRkYiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTIzLjE4OSAxNC4wMmMuMzE0LTIuMDk2LTEuMjgzLTMuMjIzLTMuNDY1LTMuOTc1bC43MDgtMi44NC0xLjcyOC0uNDMtLjY5IDIuNzY1Yy0uNDU0LS4xMTQtLjkyLS4yMi0xLjM4NS0uMzI2bC42OTUtMi43ODNMMTUuNTk2IDZsLS43MDggMi44MzljLS4zNzYtLjA4Ni0uNzQ2LS4xNy0xLjEwNC0uMjZsLjAwMi0uMDA5LTIuMzg0LS41OTUtLjQ2IDEuODQ2czEuMjgzLjI5NCAxLjI1Ni4zMTJjLjcuMTc1LjgyNi42MzguODA1IDEuMDA2bC0uODA2IDMuMjM1Yy4wNDguMDEyLjExLjAzLjE4LjA1N2wtLjE4My0uMDQ1LTEuMTMgNC41MzJjLS4wODYuMjEyLS4zMDMuNTMxLS43OTMuNDEuMDE4LjAyNS0xLjI1Ni0uMzEzLTEuMjU2LS4zMTNsLS44NTggMS45NzggMi4yNS41NjFjLjQxOC4xMDUuODI4LjIxNSAxLjIzMS4zMThsLS43MTUgMi44NzIgMS43MjcuNDMuNzA4LTIuODRjLjQ3Mi4xMjcuOTMuMjQ1IDEuMzc4LjM1N2wtLjcwNiAyLjgyOCAxLjcyOC40My43MTUtMi44NjZjMi45NDguNTU4IDUuMTY0LjMzMyA2LjA5Ny0yLjMzMy43NTItMi4xNDYtLjAzNy0zLjM4NS0xLjU4OC00LjE5MiAxLjEzLS4yNiAxLjk4LTEuMDAzIDIuMjA3LTIuNTM4em0tMy45NSA1LjUzOGMtLjUzMyAyLjE0Ny00LjE0OC45ODYtNS4zMi42OTVsLjk1LTMuODA1YzEuMTcyLjI5MyA0LjkyOS44NzIgNC4zNyAzLjExem0uNTM1LTUuNTY5Yy0uNDg3IDEuOTUzLTMuNDk1Ljk2LTQuNDcuNzE3bC44Ni0zLjQ1Yy45NzUuMjQzIDQuMTE4LjY5NiAzLjYxIDIuNzMzeiIvPjwvZz48L3N2Zz4=",
      mimeType: "image/svg+xml",
    },
    assetName: "Bitcoin",
    assetOriginalSymbol: "BTC",
    assetSymbol: "BTC",
    assetType: "crypto",
    slug: "bitcoin",
    disabled: false,
  },
  {
    assetLogo: {
      encoding: "base64",
      imageData:
        "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiI+PGcgZmlsbD0ibm9uZSI+PGNpcmNsZSBjeD0iMTYiIGN5PSIxNiIgcj0iMTYiIGZpbGw9IiNGM0JBMkYiLz48cGF0aCBmaWxsPSIjRkZGIiBkPSJNMTIuMTE2IDE0LjQwNEwxNiAxMC41MmwzLjg4NiAzLjg4NiAyLjI2LTIuMjZMMTYgNmwtNi4xNDQgNi4xNDQgMi4yNiAyLjI2ek02IDE2bDIuMjYtMi4yNkwxMC41MiAxNmwtMi4yNiAyLjI2TDYgMTZ6bTYuMTE2IDEuNTk2TDE2IDIxLjQ4bDMuODg2LTMuODg2IDIuMjYgMi4yNTlMMTYgMjZsLTYuMTQ0LTYuMTQ0LS4wMDMtLjAwMyAyLjI2My0yLjI1N3pNMjEuNDggMTZsMi4yNi0yLjI2TDI2IDE2bC0yLjI2IDIuMjZMMjEuNDggMTZ6bS0zLjE4OC0uMDAyaC4wMDJWMTZMMTYgMTguMjk0bC0yLjI5MS0yLjI5LS4wMDQtLjAwNC4wMDQtLjAwMy40MDEtLjQwMi4xOTUtLjE5NUwxNiAxMy43MDZsMi4yOTMgMi4yOTN6Ii8+PC9nPjwvc3ZnPg==",
      mimeType: "image/svg+xml",
    },
    assetName: "Bep20",
    assetOriginalSymbol: "BNB",
    assetSymbol: "BNB",
    assetType: "crypto",
    slug: "binance-coin",
    disabled: false,
  },
  {
    assetLogo: {
      encoding: "base64",
      imageData:
        "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",
      mimeType: "image/png",
    },
    assetName: "Cardano",
    assetOriginalSymbol: "ADA",
    assetSymbol: "ADA",
    assetType: "crypto",
    slug: "",
    disabled: true,
  },
  {
    assetLogo: {
      encoding: "base64",
      imageData:
        "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48Y2lyY2xlIGN4PSIxNiIgY3k9IjE2IiByPSIxNiIgZmlsbD0iIzI2QTE3QiIvPjxwYXRoIGZpbGw9IiNGRkYiIGQ9Ik0xNy45MjIgMTcuMzgzdi0uMDAyYy0uMTEuMDA4LS42NzcuMDQyLTEuOTQyLjA0Mi0xLjAxIDAtMS43MjEtLjAzLTEuOTcxLS4wNDJ2LjAwM2MtMy44ODgtLjE3MS02Ljc5LS44NDgtNi43OS0xLjY1OCAwLS44MDkgMi45MDItMS40ODYgNi43OS0xLjY2djIuNjQ0Yy4yNTQuMDE4Ljk4Mi4wNjEgMS45ODguMDYxIDEuMjA3IDAgMS44MTItLjA1IDEuOTI1LS4wNnYtMi42NDNjMy44OC4xNzMgNi43NzUuODUgNi43NzUgMS42NTggMCAuODEtMi44OTUgMS40ODUtNi43NzUgMS42NTdtMC0zLjU5di0yLjM2Nmg1LjQxNFY3LjgxOUg4LjU5NXYzLjYwOGg1LjQxNHYyLjM2NWMtNC40LjIwMi03LjcwOSAxLjA3NC03LjcwOSAyLjExOCAwIDEuMDQ0IDMuMzA5IDEuOTE1IDcuNzA5IDIuMTE4djcuNTgyaDMuOTEzdi03LjU4NGM0LjM5My0uMjAyIDcuNjk0LTEuMDczIDcuNjk0LTIuMTE2IDAtMS4wNDMtMy4zMDEtMS45MTQtNy42OTQtMi4xMTciLz48L2c+PC9zdmc+",
      mimeType: "image/svg+xml",
    },
    assetName: "Tether",
    assetOriginalSymbol: "USDT",
    assetSymbol: "USDT",
    assetType: "crypto",
    slug: "tether",
    disabled: true,
  },
  {
    assetLogo: {
      encoding: "base64",
      imageData:
        "PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIj48Y2lyY2xlIGN4PSIxNiIgY3k9IjE2IiByPSIxNiIgZmlsbD0iIzIzMjkyRiIvPjxwYXRoIGQ9Ik0yMy4wNyA4aDIuODlsLTYuMDE1IDUuOTU3YTUuNjIxIDUuNjIxIDAgMCAxLTcuODkgMEw2LjAzNSA4SDguOTNsNC41NyA0LjUyM2EzLjU1NiAzLjU1NiAwIDAgMCA0Ljk5NiAwTDIzLjA3IDh6TTguODk1IDI0LjU2M0g2bDYuMDU1LTUuOTkzYTUuNjIxIDUuNjIxIDAgMCAxIDcuODkgMEwyNiAyNC41NjJoLTIuODk1TDE4LjUgMjBhMy41NTYgMy41NTYgMCAwIDAtNC45OTYgMGwtNC42MSA0LjU2M3oiIGZpbGw9IiNGRkYiLz48L2c+PC9zdmc+",
      mimeType: "image/svg+xml",
    },
    assetName: "XRP",
    assetOriginalSymbol: "XRP",
    assetSymbol: "XRP",
    assetType: "crypto",
    slug: "ripple",
    disabled: true,
  },
  {
    assetLogo: {
      encoding: "base64",
      imageData:
        "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",
      mimeType: "image/png",
    },
    assetName: "Polkadot",
    assetOriginalSymbol: "DOT",
    assetSymbol: "DOT",
    assetType: "crypto",
    slug: "dotcoin",
    disabled: true,
  },
  {
    assetLogo: {
      encoding: "base64",
      imageData:
        "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48Y2lyY2xlIGN4PSIxNiIgY3k9IjE2IiByPSIxNiIgZmlsbD0iI0MzQTYzNCIvPjxwYXRoIGZpbGw9IiNGRkYiIGQ9Ik0xMy4yNDggMTQuNjFoNC4zMTR2Mi4yODZoLTQuMzE0djQuODE4aDIuNzIxYzEuMDc3IDAgMS45NTgtLjE0NSAyLjY0NC0uNDM3LjY4Ni0uMjkxIDEuMjI0LS42OTQgMS42MTUtMS4yMWE0LjQgNC40IDAgMCAwIC43OTYtMS44MTUgMTEuNCAxMS40IDAgMCAwIC4yMS0yLjI1MiAxMS40IDExLjQgMCAwIDAtLjIxLTIuMjUyIDQuMzk2IDQuMzk2IDAgMCAwLS43OTYtMS44MTVjLS4zOTEtLjUxNi0uOTMtLjkxOS0xLjYxNS0xLjIxLS42ODYtLjI5Mi0xLjU2Ny0uNDM3LTIuNjQ0LS40MzdoLTIuNzIxdjQuMzI1em0tMi43NjYgMi4yODZIOXYtMi4yODVoMS40ODJWOGg2LjU0OWMxLjIxIDAgMi4yNTcuMjEgMy4xNDIuNjI3Ljg4NS40MTkgMS42MDcuOTkgMi4xNjggMS43MTUuNTYuNzI0Ljk3NyAxLjU3MiAxLjI1IDIuNTQzLjI3My45NzEuNDA5IDIuMDEuNDA5IDMuMTE1YTExLjQ3IDExLjQ3IDAgMCAxLS40MSAzLjExNWMtLjI3Mi45Ny0uNjg5IDEuODE5LTEuMjUgMi41NDMtLjU2LjcyNS0xLjI4MiAxLjI5Ni0yLjE2NyAxLjcxNS0uODg1LjQxOC0xLjkzMy42MjctMy4xNDIuNjI3aC02LjU0OXYtNy4xMDR6Ii8+PC9nPjwvc3ZnPg==",
      mimeType: "image/svg+xml",
    },
    assetName: "Dogecoin",
    assetOriginalSymbol: "DOGE",
    assetSymbol: "DOGE",
    assetType: "crypto",
    slug: "dogecoin",
    disabled: true,
  },
  {
    assetLogo: {
      encoding: "base64",
      imageData:
        "iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAMAAACdt4HsAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAMAUExURUxpcQB/fzNcnDNcnAAA/zRcnT8/f1VVqjNdnDRdnAAAADRcnTNdnTNdnDNdm39/fzNdnjRdnTNmmTRdnTVjojNcmzVVlTNbmzVfoTNcnDZgojVgojVfoTRenzNmmThVqjNMkzdjpzVfoDRdnTRdni5cojRbnTNcnDNdnTNioTRdnTNcnThkqTNdnjRcnDNdnTVfoTVcnDNcnDNdnTRfoD1VVTVfoDNcnDRfoTVfoGqa/zVenzNcnDVfoDReoDRfnzNdnjRdnDRenzNdnTNcnDVenzNdnjRcnS5cizVgoTRXlTReoDVdnzJZmjZenTNenDRcnDVeoTRdnjRenjRdnTNcnjReoDNenjNmqjNepTRdnjRdnjFemzVfoDRdnTNbmzNcnTNdmzVcnDNbmzVfoDFYkzRenzNbmTlcojNdnDRdnDNdnTNcnDRdnTRdnDVenzVdnzVdnTRdnf///zdfnjdipfz9/idTl3mUvjVdnf7+/jZfnv39/jVenf7+/zdgnzhkqTJcnDpioDdipvz8/ebr8zdjpzVeniZSljVfoDVfoS5ZmitWmThkqP3+/iVRli1YmjRenjZenjJbnDdjqDZgo/7//yhUlzZhpDZgoilVmDlhnzNcndLb6TdjpjBamzZho9Pc6j1koSlUmGiHtvv8/S9ZmzFbnPn6/ChTlzRdnoCawjVgoe3x93iTvixXmTdfn4aexC1XmfX3+uPo8Vt8sCdSl/b4+/Dz+MDN4WGCs7HB2qq71vP2+StWmIefxeXr8/z9/TdipOfs9Pr7/HqVv8jT5U9yq5eszVd5rq2+2Elup0xwqeTq8oOcw0ZrpZWqzN3k70FnozFamzhgn3OQu6K10rTD28fS5Jywz1V3raO20tTd6ujs89rh7Yqixoykx+Hn8Ovv9URppNvi7sXR42+MuaS3087X56y913CNukFoo7nI3UVqpVZ4rl5/sYSdwyBNk7vJ3nuVv5Gnyo6lyTtjoCRRlWGAssvW5nKOu73K387Y5xtJkUdspk1xqc9xuHgAAABydFJOUwAC+/0B/QQD/P4B+vv7/AJK/gUrDvwXb0tx/vf5/AoJCv7YXGILee5HEL9f/i3+478ww99pA9nX0tsBbqjJpKZySOqLSl9maAvXHcjKHip3pqe84/lFiXcPEr/6Lr3gbdhfW8XTGssZFqmmp+fmieuLi+6BIMEAAAW4SURBVFjDjVd3XBNnGP5IDrIIUxEciAxFBfdGRRFbqXvW0b33uEug4cjA2CSEACFskL1BRQRx1NXWUeuotq4Ou/fee313lwu5y3eB5x9+JHnf+97ne+593wcAT8glEurPkNCNMRGrV0fEbFw1hPpfIpGDwUBORY8P2rRu/YacOjVEXc6G9es2BW2hcgwiBQz3C1+YojYYrYUyXymEb3Ch1WhQpywMktBfe4UPBiJnzCk35YiVUlkw7kSwTKoU55jK58yIApiPt3g/AJbOKi4RS2W4B2RScUlx9FL6RwLAZoKpU0wVQ31xAfgOrTDdeQd1TPTxAUgaoQ4QDKdTSI0jkuifotiLSs7rkOIDQFqYtzAKxaUEhC0wKPm1k2YtDdKNC6VheZhnBglYmVaj4D9Oa7O35FI4lu32qcKUdhs/gw8IizaK+PGkrbu6ur6+vrr+C87nImP0I1wesMDIFTUe8dqihqMEg91XdmrcM5iWjw7EOPc/3+ARj5ONTURzFsTJ9CMWPfcMhjXuepCAYQaFJ+H6gs+IHdTzs4ir7SrudwrD3f00BILQkaMQ2sOLPibyYbyOOPpRrZany1EjV4F5zgQz500zIu7f0XU2q5Q6QDrxSSXJ/zbAOE0uYQuIKfbHURW8z1Swg3iPRwEFpek+hgYMi5w+HKVf0nYaPpzm4K19Dk9VD58+GsPoG7g1bygiXtvyWg8sn4A0vFuEEnVA3i30EbCQ2SWoA6gy9kD66QreLtCjXqy62SGYHOZYrBajHqC3vMBQkEk0eXJIQfxSPAyXgMfHoCjUZFfdhLHUJe5uKNKiEviPWUNpYci4HJQGyMrDdDzxIvE1X0WsFnLGbYYcBAlUUPAmU0E60WnRo3uDWB0PEyxJUOLIS3iH5rCUaDufa0YnECU8BRNMUKO6kMN+ppnRAFFtNwt1J+MESMGTVhnyDrpZGb7St92MFAI+adfkOJCoKAxGcdh4iJGhjvj9t/Z9v6KP0KEIBfHIA2jfeP2gU4aXa89cPN2dsRd5D9YgMLEcKcOyTxkZ6ogLf0Ay9tuQUvKtmwgWITmsKjvCUABvASbpbRVgUT0MjPVMQOod+459QPcSGpmXL6IPABPcjkpgs9jP/Zyvo5+vO3Djl7O4TYsLJkCUsP/S323Oh2cR3/9Q1oWTuHAJfBJVZVeZSIaAtnO1VQ7hUQlJ5F+jvuA6Tb7zAJ/bHV4GpcyaChJFHCFBARzoudF5je0llwr0XhJQQtr8BOcI5pb/Ov+1//OXU4Y6AQG4SZn/Mmlb+2qLXN2w1+x11FMvE3yduQ1Jo7rS/idbwRGLtwqUCUuQDUVveZUdaV+WqbwkEKsXUyuhR0vbSfY6R9rBr1rNGg54LW08NZfm85oqafuOucZ04lCGNpsLLaepPgbD/Txq0BdcYrvh8a6G7RxU5XLa+mJqsmAh93AHi9le7RQi8eGJm8+748KJ442ua/UtoQeLx2gz555vI0oJAVzrF5ZrtGFxd7kP172WTudMhTRmcpCfnnnYNaRcwxXycK/7eCfLfoTDBIlM4uWqbI1rvMewW06gz/39aoSb1W72XeJjh+56hsqlwmlwNUasOKrGpqzmdCSyThI/9alcK04oDEQsWdRQFkTPN7VmxJIF5H7gUXbN07Q2ndrzHBJ7Tn3LDjmRYT5n7cfmRT7ELpqaygxBsENOZFrBXTTh3vrwXHbVJVWCcLhW3TD+yg+X7Vk1CnxQUNSkrUSt6w8uMIhkA4fLRIYFYWjDsGxtXuFgDEdyFNq8waIWDWh5AowjIgQsD6Ac3QCmK6DCNGWqoOlibF/s3OIKYds3N9ab7aPKkIO4pAfU0Hj6Syf1G89JUn9oPNVzZiwbwHgy1jckfO3T0Ovu6nBaX1nhLuiEU5LDQwa2vqz53hL+zNbJ26zllPkut26bvPXZ8MGabzf7n5gaGzF2bERsaqIX+/8/rDeCbjJNPnAAAAAASUVORK5CYII=",
      mimeType: "image/png",
    },
    assetName: "Litecoin",
    assetOriginalSymbol: "LTC",
    assetSymbol: "LTC",
    assetType: "crypto",
    slug: "litecoin",
    disabled: true,
  },
  {
    assetLogo: {
      encoding: "base64",
      imageData:
        "PHN2ZyBoZWlnaHQ9IjMyIiB3aWR0aD0iMzIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48Y2lyY2xlIGN4PSIxNiIgY3k9IjE2IiBmaWxsPSIjOGRjMzUxIiByPSIxNiIvPjxwYXRoIGQ9Ik0yMS4yMDcgMTAuNTM0Yy0uNzc2LTEuOTcyLTIuNzIyLTIuMTUtNC45ODgtMS43MWwtLjgwNy0yLjgxMy0xLjcxMi40OTEuNzg2IDIuNzRjLS40NS4xMjgtLjkwOC4yNy0xLjM2My40MWwtLjc5LTIuNzU4LTEuNzExLjQ5LjgwNSAyLjgxM2MtLjM2OC4xMTQtLjczLjIyNi0xLjA4NS4zMjhsLS4wMDMtLjAxLTIuMzYyLjY3Ny41MjUgMS44M3MxLjI1OC0uMzg4IDEuMjQzLS4zNThjLjY5NC0uMTk5IDEuMDM1LjEzOSAxLjIuNDY4bC45MiAzLjIwNGMuMDQ3LS4wMTMuMTEtLjAyOS4xODQtLjA0bC0uMTgxLjA1MiAxLjI4NyA0LjQ5Yy4wMzIuMjI3LjAwNC42MTItLjQ4Ljc1Mi4wMjcuMDEzLTEuMjQ2LjM1Ni0xLjI0Ni4zNTZsLjI0NyAyLjE0MyAyLjIyOC0uNjRjLjQxNS0uMTE3LjgyNS0uMjI3IDEuMjI2LS4zNGwuODE3IDIuODQ1IDEuNzEtLjQ5LS44MDctMi44MTVhNjUuNzQgNjUuNzQgMCAwIDAgMS4zNzItLjM4bC44MDIgMi44MDMgMS43MTMtLjQ5MS0uODE0LTIuODRjMi44MzEtLjk5MSA0LjYzOC0yLjI5NCA0LjExMy01LjA3LS40MjItMi4yMzQtMS43MjQtMi45MTItMy40NzEtMi44MzYuODQ4LS43OSAxLjIxMy0xLjg1OC42NDItMy4zem0tLjY1IDYuNzdjLjYxIDIuMTI3LTMuMSAyLjkyOS00LjI2IDMuMjYzbC0xLjA4MS0zLjc3YzEuMTYtLjMzMyA0LjcwNC0xLjcxIDUuMzQuNTA4em0tMi4zMjItNS4wOWMuNTU0IDEuOTM1LTIuNTQ3IDIuNTgtMy41MTQgMi44NTdsLS45OC0zLjQxOWMuOTY2LS4yNzcgMy45MTUtMS40NTUgNC40OTQuNTYzeiIgZmlsbD0iI2ZmZiIgZmlsbC1ydWxlPSJub256ZXJvIi8+PC9nPjwvc3ZnPg==",
      mimeType: "image/svg+xml",
    },
    assetName: "Bitcoin Cash",
    assetOriginalSymbol: "BCH",
    assetSymbol: "BCH",
    assetType: "crypto",
    slug: "bitcoin-cash",
    disabled: true,
  },
];

export const WALLETS = [
  {
    key: 1,
    value: "21312785123871952375123",
    label: "23129836128736-192836187230789123",
    disabled: false,
  },
  {
    key: 2,
    value: "21231312785123871952375123",
    label: "2312123989836128736-192836187230789123",
    disabled: false,
  },
];

export const walletValidationSchema = (cointype: string) =>
  Yup.string()
    .required("You need to enter your wallet address")
    .test(
      "user_wallet_address",
      "Please enter a correct wallet address.",
      function (value) {
        if (value) return walletValidator.validate(value, cointype);

        return false;
      }
    );

export const usdTocoin = (usd: number, coinPrice: number) => usd / coinPrice;
const time : any = new Date().toUTCString()

export const remainingTimeCalc = (timestampInSeconds: number = 0) =>
  timestampInSeconds - Math.floor(Date.now()  / 1000);


export const totalProfitPercentRatio = 3.8532;
export const monthlyReturnPercentRatio = 0.04;
export const aDayInSeconds = 86400;
export const daysInAMonth = 30;
export const hoursInADay = 24;
export const dailyReturnPercentRatio = 0.0013;
